// components/partnerOnboarding/StepIndicator.js
import React from 'react';

function StepIndicator({ currentStep, totalSteps }) {
  const steps = [
    "Personal Info",
    "Promotion Links",
    "Dashboard Tour"
  ];

  return (
    <div className="step-indicator mb-4">
      {steps.map((step, index) => (
        <div key={index} className={`step ${currentStep === index + 1 ? 'active' : ''}`}>
          {step}
        </div>
      ))}
    </div>
  );
}

export default StepIndicator;